import * as yup from 'yup';

export const generateSignDocumentsSchema = ({
  firstName,
  lastName,
  targetSignature,
}: {
  firstName?: string;
  lastName?: string;
  targetSignature?: string;
}) => {
  return yup
    .object({
      signature: yup
        .string()
        .trim()
        .max(128)
        .required('Your signature is required to purchase shares')
        .test({
          name: 'firstNameMatchesRule',
          test: (val: string | undefined) => {
            return !(val && firstName) || val.toLowerCase().startsWith(firstName.toLowerCase());
          },
          message: 'First name does not match',
        })
        .test({
          name: 'lastNameMatchesRule',
          test: (val: string | undefined) => {
            return !(val && lastName) || val.toLowerCase().endsWith(lastName.toLowerCase());
          },
          message: 'Last name does not match',
        })
        .test({
          name: 'signatureMatchesCaseSensitiveRule',
          test: (val: string | undefined) => {
            return !(val && targetSignature) || val === targetSignature;
          },
          message: 'Signature capitalization does not match',
        })
        .test({
          name: 'signatureMatchesCaseInsensitiveRule',
          test: (val: string | undefined) => {
            return !(val && targetSignature) || val.toLowerCase() === targetSignature.toLowerCase();
          },
          message: 'Signature does not match',
        }),
    })
    .defined();
};

export const signDocumentsSchema = generateSignDocumentsSchema({});

export type SignDocumentsSchema = yup.InferType<typeof signDocumentsSchema>;
